const FALLBACK_ICON = "/shop-icon.svg";
const setIcons = source => {
  document.querySelectorAll('link[rel="icon"],link[rel="shortcut icon"],link[rel="apple-touch-icon"]:not([data-pwa-icon])').forEach(link => link.remove());
  for (const rel of ["icon", "apple-touch-icon"]) {
    if (rel === "apple-touch-icon" && document.querySelector("[data-pwa-icon]")) continue;
    const link = document.createElement("link");
    link.rel = rel;
    link.href = source;
    link.dataset.shopBrandIcon = source;
    document.head.appendChild(link);
  }
};
export const applyShopBranding = ({ name, favIcon, logo }) => {
  let active = true;
  const images = [];
  document.title = name || "Tienda";
  setIcons(FALLBACK_ICON);
  const candidates = [...new Set([favIcon, logo].filter(Boolean))].filter(source => {
    try { return ["http:", "https:"].includes(new URL(source, window.location.origin).protocol); } catch { return false; }
  });
  const load = index => {
    if (!active || index >= candidates.length) return;
    const image = new Image(); images.push(image);
    image.onload = () => { if (active) setIcons(candidates[index]); };
    image.onerror = () => load(index + 1);
    image.src = candidates[index];
  };
  load(0);
  return () => { active = false; images.forEach(image => { image.onload = null; image.onerror = null; }); };
};
